/* ============================================================
   KHAVIYAR — Immersive : quick buy  (v3)
   One click from the homepage to checkout.

   Buy now -> native form POST /cart/add?return_to=/checkout.
              Zero JS dependency. Cannot silently break.
   Add     -> Savor's own pipeline, learned from its source:
              1. POST /cart/add.js with `sections` = the drawer's
                 section id (Section Rendering API), exactly as
                 Savor's product form does.
              2. Swap the fresh HTML into the drawer's existing
                 <dialog> (same node, so component refs survive)
                 and sync its class list (empty -> filled state).
              3. GET /cart.js, then dispatch 'cart:update' with
                 detail.data.itemCount — the contract cart-icon.js
                 requires. A bare event reads as itemCount 0 and
                 HIDES the bubble, which is the v2 bug.
              4. cartDrawerComponent.open()  (public method).
              Fallback when no drawer exists: a visible
              "View cart" link. Errors surface in the status line.
   ============================================================ */
(function () {
  "use strict";

  /* ---- Savor cart integration ------------------------------------------- */

  function drawerParts() {
    var component = document.querySelector("cart-drawer-component");
    if (!component) return null;
    var section = component.closest(".shopify-section");
    return {
      component: component,
      dialog: component.querySelector("dialog"),
      sectionId: section ? section.id.replace(/^shopify-section-/, "") : null
    };
  }

  function addToCart(variantId) {
    var d = drawerParts();
    var payload = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (d && d.sectionId) payload.sections = d.sectionId;

    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) {
            var msg = (json && (json.description || json.message)) || "Could not add to cart";
            throw new Error(msg);
          }
          return json;
        });
      })
      .then(function (added) {
        return fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return { added: added, cart: cart }; });
      })
      .then(function (result) {
        var opened = false;

        /* 1. Refresh the drawer DOM from the section-rendered HTML. */
        if (d && d.dialog && d.sectionId && result.added.sections && result.added.sections[d.sectionId]) {
          try {
            var holder = document.createElement("div");
            holder.innerHTML = result.added.sections[d.sectionId];
            var fresh = holder.querySelector("cart-drawer-component dialog");
            if (fresh) {
              d.dialog.innerHTML = fresh.innerHTML;
              /* Empty vs filled state lives on the dialog's class list. */
              d.dialog.className = fresh.className;
              var labelled = fresh.getAttribute("aria-labelledby");
              if (labelled) d.dialog.setAttribute("aria-labelledby", labelled);
            }
          } catch (e) { /* drawer stays stale; bubble + link still tell the truth */ }
        }

        /* 2. Tell the theme the real count. cart-icon.js reads
              detail.data.itemCount and treats a non-product-form
              source as an absolute value. */
        document.dispatchEvent(new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: null,
            sourceId: "kh-quickbuy",
            data: { source: "kh-quickbuy", itemCount: result.cart.item_count }
          }
        }));

        /* 3. Show the drawer. */
        if (d && typeof d.component.open === "function") {
          try { d.component.open(); opened = true; } catch (e) {}
        }

        return { cart: result.cart, opened: opened };
      });
  }

  /* ---- variant pill groups (homepage signature panels) ------------------- */
  document.querySelectorAll("[data-kh-buy]").forEach(function (root) {
    var opts = Array.prototype.slice.call(root.querySelectorAll(".kh-buy__opt"));
    /* The price lives in .kh-sig__price, a SIBLING of .kh-buy, so it must be
       looked up from the surrounding panel. */
    var scope = root.closest(".kh-sig__body") || root.parentElement || root;
    var priceEl = scope.querySelector("[data-kh-price]");
    var status = root.querySelector("[data-kh-status]");
    var buyBtn = root.querySelector("[data-kh-buynow]");
    var addBtn = root.querySelector("[data-kh-addcart]");
    if (!opts.length) return;

    function selected() {
      return opts.filter(function (o) { return o.getAttribute("aria-checked") === "true"; })[0];
    }

    function say(msg, isHtml) {
      if (!status) return;
      if (isHtml) { status.innerHTML = msg || ""; } else { status.textContent = msg || ""; }
      status.classList.toggle("is-on", !!msg);
    }

    function sync() {
      var s = selected();
      var ok = !!s && s.getAttribute("data-available") === "true";
      [buyBtn, addBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = !ok;
        b.style.opacity = ok ? "" : "0.4";
        b.style.pointerEvents = ok ? "" : "none";
      });
      if (s && priceEl) priceEl.textContent = s.getAttribute("data-price-money") || priceEl.textContent;
      if (s && !ok) say("Sold out in this size");
      else say("");
    }

    function pick(o) {
      opts.forEach(function (x) { x.setAttribute("aria-checked", String(x === o)); });
      sync();
    }

    opts.forEach(function (o) {
      o.addEventListener("click", function () { pick(o); });
      o.addEventListener("keydown", function (e) {
        var i = opts.indexOf(o);
        if (e.key === "ArrowRight" || e.key === "ArrowDown") {
          e.preventDefault(); opts[(i + 1) % opts.length].focus(); pick(opts[(i + 1) % opts.length]);
        } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
          e.preventDefault(); opts[(i - 1 + opts.length) % opts.length].focus(); pick(opts[(i - 1 + opts.length) % opts.length]);
        }
      });
    });

    /* Buy now: one click straight to checkout. Native form, no fetch. */
    if (buyBtn) {
      buyBtn.addEventListener("click", function () {
        var s = selected();
        if (!s || s.getAttribute("data-available") !== "true") return;
        buyBtn.textContent = "Taking you to checkout…";
        var f = document.createElement("form");
        f.method = "post";
        f.action = "/cart/add";
        f.hidden = true;
        f.innerHTML =
          '<input name="id" value="' + s.getAttribute("data-vid") + '">' +
          '<input name="quantity" value="1">' +
          '<input name="return_to" value="/checkout">';
        document.body.appendChild(f);
        f.submit();
      });
    }

    /* Add to cart: stay put, drawer opens with the item in it. */
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        var s = selected();
        if (!s || s.getAttribute("data-available") !== "true") return;
        var label = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = "Adding…";
        addToCart(s.getAttribute("data-vid"))
          .then(function (res) {
            addBtn.textContent = "Added";
            if (!res.opened) {
              say('In your cart · <a href="/cart" style="color:#e7d3a1">View cart</a>', true);
            }
            setTimeout(function () { addBtn.textContent = label; addBtn.disabled = false; }, 2200);
          })
          .catch(function (err) {
            addBtn.textContent = label;
            addBtn.disabled = false;
            say(err && err.message ? err.message : "That did not go through");
          });
      });
    }

    sync();
  });

  /* ---- quick add on ritual cards ---------------------------------------- */
  document.querySelectorAll("[data-kh-quickadd]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var id = btn.getAttribute("data-vid");
      if (!id) return;
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Adding…";
      addToCart(id)
        .then(function () {
          btn.textContent = "Added";
          btn.classList.add("is-done");
          setTimeout(function () {
            btn.textContent = label;
            btn.classList.remove("is-done");
            btn.disabled = false;
          }, 2200);
        })
        .catch(function (err) {
          btn.textContent = (err && err.message && err.message.length < 32) ? err.message : "Try product page";
          setTimeout(function () {
            btn.textContent = label;
            btn.disabled = false;
          }, 2600);
        });
    });
  });
})();
